var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "referrer_box" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 12 } }, [
            this.$route.query.faqId == null
              ? _c("div", { staticClass: "faq-title" }, [
                  _vm._v("\n        Create FAQ\n      ")
                ])
              : _c("div", { staticClass: "faq-title" }, [
                  _vm._v("\n        Edit FAQ\n      ")
                ])
          ]),
          _vm._v(" "),
          _c("el-col", { staticClass: "back-col", attrs: { span: 12 } }, [
            _c(
              "div",
              {
                staticClass: "back-btn",
                on: {
                  click: function($event) {
                    return _vm.goBack()
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "el-icon-arrow-left",
                  staticStyle: { "font-weight": "bolder" }
                }),
                _vm._v("BACK\n      ")
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "formFaqDetails",
          staticClass: "addruleForm",
          attrs: {
            model: _vm.formFaqDetails,
            "label-position": "top",
            rules: _vm.ruleFaqDetails,
            "hide-required-asterisk": true,
            "label-width": "250px"
          },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { "margin-top": "20px" }, attrs: { span: 24 } },
                [
                  _c("div", { staticClass: "textFieldsStyle" }, [
                    _vm._v("Question")
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      placeholder: "Question...",
                      maxlength: "1000",
                      type: "textarea",
                      rows: 2,
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.formFaqDetails.question,
                      callback: function($$v) {
                        _vm.$set(_vm.formFaqDetails, "question", $$v)
                      },
                      expression: "formFaqDetails.question"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { "margin-top": "10px" }, attrs: { span: 24 } },
                [
                  _c("div", { staticClass: "textFieldsStyle" }, [
                    _vm._v("Answer")
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      placeholder: "Answer...",
                      maxlength: "100000",
                      type: "textarea",
                      rows: 10
                    },
                    model: {
                      value: _vm.formFaqDetails.answer,
                      callback: function($$v) {
                        _vm.$set(_vm.formFaqDetails, "answer", $$v)
                      },
                      expression: "formFaqDetails.answer"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { "margin-top": "10px" }, attrs: { span: 24 } },
                [
                  _c("div", { staticClass: "textFieldsStyle" }, [
                    _vm._v("Position")
                  ]),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { placeholder: "Position...", type: "number" },
                    model: {
                      value: _vm.formFaqDetails.position,
                      callback: function($$v) {
                        _vm.$set(_vm.formFaqDetails, "position", $$v)
                      },
                      expression: "formFaqDetails.position"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            {
              staticStyle: { "padding-top": "20px", "margin-top": "20px" },
              attrs: { gutter: 20 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { type: "text" },
                      on: { click: _vm.navigateToAllFaqs }
                    },
                    [_vm._v("\n          Cancel\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  this.$route.query.faqId == null
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn-create-faq",
                          on: {
                            click: function($event) {
                              return _vm.createFaq("formFaqDetails")
                            }
                          }
                        },
                        [
                          _vm._v("\n          Create FAQ\n          "),
                          _vm.submitting
                            ? _c("i", { staticClass: "el-icon-loading" })
                            : _vm._e()
                        ]
                      )
                    : _c(
                        "el-button",
                        {
                          staticClass: "btn-create-faq",
                          on: {
                            click: function($event) {
                              return _vm.modifyFaq("formFaqDetails")
                            }
                          }
                        },
                        [
                          _vm._v("\n          Update FAQ\n          "),
                          _vm.submitting
                            ? _c("i", { staticClass: "el-icon-loading" })
                            : _vm._e()
                        ]
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ed72f3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ed72f3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faq/createFaq.vue
// module id = null
// module chunks = 